import { render, staticRenderFns } from "./AssessmentGroupEvaluationCriteria.vue?vue&type=template&id=392dd618&scoped=true"
import script from "./AssessmentGroupEvaluationCriteria.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupEvaluationCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392dd618",
  null
  
)

export default component.exports